import React, {useEffect} from "react";
import {useGetMyHouses, useMyHouses} from "../stores/otherStore";
import HouseCard from "../HouseCard";

const ProfileDetail = () => {
    const myHouses = useMyHouses();
    const getMyHouses = useGetMyHouses();

    const token = localStorage.getItem("access_token");

    useEffect(() => {
            void getMyHouses(token);
    }, [getMyHouses, token]);

    return (
        <div className="bg-cover py-5"
             style={{backgroundImage: `url(https://www.sipa.columbia.edu/sites/default/files/styles/16_9_2400x1350/public/2023-02/kevin-matos-Nl_FMFpXo2g-unsplash_0.jpg.jpeg?itok=LnC0-MUX)`}}>
            <div className={'max-w-screen-xl pt-5 mx-auto bg-white/20 backdrop-blur-lg rounded-xl shadow-lg'}>

                <p className="my-3 px-5 mx-auto text-white text-lg lg:w-11/12 md:w-11/12">Результаты найденных ваших обьявлений: {myHouses.length}</p>

                <div className="w-full px-16 pb-5 md:px-0 min-h-[50vh]">
                    {myHouses.length === 0 && (
                        <div
                            className="border w-fit bg-white/20 mx-auto border-gray-200 flex mt-10 flex-col items-center justify-center px-4 md:px-8 lg:px-24 py-8 rounded-lg shadow-2xl">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-search"
                                style={{color: "rgb(160, 174, 192)", fontSize: "48px", marginBottom: "16px"}}
                            >
                                <circle cx="11" cy="11" r="8"></circle>
                                <path d="m21 21-4.3-4.3"></path>
                            </svg>
                            <p className="text-white mt-4 pb-4 border-b-2 text-center">
                                У вас пока что нет обьявлений
                            </p>
                        </div>
                    )}

                    <div className="flex lg:w-11/12 px-3 bg-white/40 rounded-xl md:w-11/12 mx-auto flex-wrap lg:gap-14">
                        {myHouses.map((house) => (
                            <HouseCard key={house.id} house={house}/>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfileDetail;
